import { VideoStream } from '../../components/types/videos';

export interface Resolution {
	label: string;
	value: {
		height: number;
		width: number;
	};
}

export enum SrtStreamStatus {
	active = 'active',
	idle = 'idle',
	disabled = 'disabled',
}

export interface SrtStream {
	id: number;
	playbackId: string;
	muxId: string;
	streamKey: string;
	srtPassphrase: string;
	status: SrtStreamStatus;
	thumbnail: string;
	name: string;
	safetyImage: string;
	volume: number;
	muted: boolean;
	videoMuted: boolean;
	createdAt?: Date;
	updatedAt?: Date;
}

export interface OnsiteLocation {
	id: number;
	meeting?: number;
	channel?: number;
	meetingOrder: number;
	locationName: string;
	pathName: string;
	safetyImage: string;
	holdSlide: string;
	cloudConvertId: string | null;
	advancedAudio: boolean;
	resolution1080p: boolean;
	hideSelfView: boolean;
	useSlideDeck: boolean;
	srtId: number | null;
	useSrt: boolean;
	inputType?: 'cam_mic' | 'srt' | 'whip' | 'rtmp' | null;
	inputId?: string | null;
	deleted?: boolean;
	createdAt?: Date;
	updatedAt?: Date;
}

export interface PreviousLocation {
	locationName: string;
	safetyImage: string;
	holdSlide: string;
}

export interface OnsiteLocationStream {
	id: string;
	srcObject: MediaStream;
}

export interface OnsiteLocationSession {
	id: number | null;
	route: OnsiteLocationSessionRoute;
}

export enum OnsiteLocationSessionRoute {
	Entry = 'entry',
	Publishing = 'publishing',
	Canvas = 'canvas',
	LimitedInputCanvas = 'limited-input-canvas',
}

export interface VideoState {
	selectedVideo: MediaDeviceInfo | null;
	selectedAudio: MediaDeviceInfo | null;
	selectedOutput: MediaDeviceInfo | null;
	displayName: string;
	connectionReady: boolean;
	liveVideoMap: string[];
	liveVideoUpdated: boolean;
	mainVideoStream: any;
	sharingScreen: boolean;
	connectedPresenterVideos: VideoStream[];
	connectedMediaVideos: VideoStream[];
	videoDevices: MediaDeviceInfo[];
	audioDevices: MediaDeviceInfo[];
	audioOutputs: MediaDeviceInfo[];
	availableResolutions: Resolution[];
	selectedResolution: Resolution;
	isLive: boolean;
	// preference set during onboarding and passed into opentok
	videoMuted: boolean;
	// preference set during onboarding and passed into opentok
	audioMuted: boolean;
	previewMode: boolean; // true if user is in the settings tab while isLive is false
	hiddenTitles: Array<number>;
	useMobile: boolean;
	isInitialDeviceLoad: boolean;
	feedWebRTCIds: string[];
	shouldRepublishVideo: boolean;
	srtStreams: SrtStream[];
	selectedSrtStreamId: number;
	onsiteLocations: OnsiteLocation[]; // db data for onsite locations
	onsiteLocationsLoaded: boolean;
	onsiteLocationStreams: Map<number, OnsiteLocationStream[]>; // opentok streams for each location
	onsiteLocationSession: OnsiteLocationSession | null; // page state for onsite location session
	selectedOnsiteLocationId: number;
	screenshareVideoSource: string | null;
}

export interface Bitrate {
	[key: string]: number;
}
